module.exports = __webpack_public_path__ + "img/leadlovers.232daa21.svg";